import React from "react";

const SendIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.4997 12.5L4.8957 7.063C4.7227 5.507 6.3247 4.364 7.7397 5.035L19.6837 10.693C21.2087 11.415 21.2087 13.585 19.6837 14.307L7.7397 19.966C6.3247 20.636 4.7227 19.494 4.8957 17.938L5.4997 12.5ZM5.4997 12.5H12.4997"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default SendIcon;
